import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import ShortcutsPopupContentQuery from '@atlassian/jira-relay/src/__generated__/ShortcutsPopupContentQuery.graphql';

export const shortcutMenuContentEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-horizontal-nav-shortcuts-menu-content" */ './ShortcutsPopupContent'
			),
	),
	getPreloadProps: ({ cloudId, projectIdOrKey }: { cloudId: string; projectIdOrKey: string }) => ({
		queries: {
			mainQuery: {
				parameters: ShortcutsPopupContentQuery,
				variables: {
					cloudId,
					projectIdOrKey,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
